/* Native Shopify discovery, progressively enhanced with keyboard-safe dialogs. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const triggers = new WeakMap();
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open-dialog]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.openDialog);
      if (!dialog?.showModal) return;
      event.preventDefault(); triggers.set(dialog, trigger); dialog.showModal();
      (dialog.querySelector('input[type="search"]') || dialog.querySelector('[data-close-dialog]'))?.focus();
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('dialog.shopping-dialog')) {
      const r = event.target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) event.target.close();
    }
  });
  document.querySelectorAll('.shopping-dialog').forEach(dialog => {
    dialog.addEventListener('close', () => triggers.get(dialog)?.focus());
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dialog.close(); }
    });
  });
  document.querySelectorAll('[data-mega]').forEach(menu => {
    let timer, openedByHover = false;
    menu.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { clearTimeout(timer); openedByHover = !menu.open; menu.open = true; } });
    menu.querySelector('summary').addEventListener('click', event => {
      if (event.detail > 0 && openedByHover) event.preventDefault();
      openedByHover = false;
    });
    menu.addEventListener('pointerleave', () => { timer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 220); });
    menu.addEventListener('focusout', () => { setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 0); });
    document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
  });
  const filter = document.querySelector('[data-filter-panel]');
  const slot = document.querySelector('[data-filter-slot]');
  const filterDialog = document.getElementById('FilterDialog');
  if (filter && filterDialog) {
    const media = matchMedia('(max-width: 900px)');
    const place = () => { if (!media.matches && filterDialog.open) filterDialog.close(); (media.matches ? filterDialog.querySelector('[data-filter-content]') : slot).append(filter); };
    media.addEventListener('change', place); place();
  }
  const input = document.querySelector('[data-predictive-input]');
  if (!input) return;
  let timer, controller, revision = 0;
  const results = document.querySelector('[data-search-results]');
  const status = document.querySelector('[data-search-status]');
  input.addEventListener('input', () => {
    clearTimeout(timer); controller?.abort(); const current = ++revision;
    const q = input.value.trim(); results.replaceChildren();
    if (!q) { status.textContent = 'Search our entire collection.'; return; }
    status.textContent = 'Searching…';
    timer = setTimeout(async () => {
      controller = new AbortController();
      const params = new URLSearchParams({ q, section_id: 'predictive-search', 'resources[type]': 'product', 'resources[limit]': '6', 'resources[options][fields]': 'title,body,product_type,tag,variants.title' });
      try {
        const response = await fetch(root + 'search/suggest?' + params, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (current !== revision) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const section = parsed.querySelector('#shopify-section-predictive-search');
        if (!section) throw new Error('Invalid search response');
        results.replaceChildren(...section.childNodes);
        status.textContent = `${results.querySelectorAll('.predictive-item').length} suggestions. Use Tab to explore or Enter for all results.`;
      } catch (error) {
        if (error.name !== 'AbortError' && current === revision) status.textContent = 'Suggestions are unavailable. Press Enter to search all products.';
      }
    }, 220);
  });
})();
